export default __webpack_public_path__ + "img/Poppins-Bold_22cfe96.eot";